var map = {
	"./agpay/third-logo.png": "1cd4",
	"./aipay/third-logo.png": "432c",
	"./anpay/third-logo.png": "12f0",
	"./qpay/third-logo.png": "47f9",
	"./qtpay/third-logo.png": "59cd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4656";